import '../../.cache/site-build/tailwind.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/brands.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import HSCollapse from 'preline/plugins/collapse-non-auto';
import HSDropdown from 'preline/plugins/dropdown-non-auto';
import { api } from './config';

// Only the components used by the Tailwind pages.
HSCollapse.autoInit();
HSDropdown.autoInit();

const setAuthenticationState = (authenticated) => {
  document.querySelectorAll('[data-auth-content="authenticated"]').forEach((element) => {
    element.hidden = ! authenticated;
  });
  document.querySelectorAll('[data-auth-content="anonymous"]').forEach((element) => {
    element.hidden = authenticated;
  });
};

const requestApiUser = token => fetch(api.getuser.url, {
  credentials: 'include',
  headers: token
    ? { Accept: 'application/json', 'X-Auth-Token': token }
    : { Accept: 'application/json', 'X-Auth-Source': 'session' },
});

const refreshAuthenticationState = () => {
  const token = localStorage.getItem('api_token') || '';

  requestApiUser(token).then((response) => {
    // A stale legacy token must not hide a valid cookie-based session.
    if ((response.status === 401 || response.status === 403) && token) {
      localStorage.removeItem('api_token');
      return requestApiUser('');
    }
    return response;
  }).then((response) => {
    if (response.status === 401 || response.status === 403) {
      setAuthenticationState(false);
      return null;
    }
    if (! response.ok) return null;
    return response.json();
  }).then((data) => {
    if (data) setAuthenticationState(Boolean(data?.user?.id));
  })
  // Keep the cookie-based initial state when the API cannot be reached.
  .catch(() => {});
};

window.addEventListener('DOMContentLoaded', refreshAuthenticationState, { once: true });

const mobileNavigation = window.matchMedia('(max-width: 991.98px)');

document.querySelectorAll('[data-mobile-dropdown-toggle]').forEach((dropdownToggle) => {
  // Keep section links on desktop, but make the whole row a disclosure on mobile.
  dropdownToggle.addEventListener('click', (event) => {
    if (mobileNavigation.matches) event.preventDefault();
  }, { capture: true });
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.hs-dropdown').forEach((dropdown) => {
    HSDropdown.getInstance(dropdown)?.resizeHandler();
  });
});

const toggle = document.querySelector('[data-hs-collapse="#site-navigation"]');

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && toggle?.getAttribute('aria-expanded') === 'true') {
    HSCollapse.hide(toggle);
    if (toggle.getAttribute('aria-expanded') === 'true') {
      window.setTimeout(() => HSCollapse.hide(toggle), 350);
    }
    toggle.focus();
  }
});
